Billy.AccountGroup.reopen({
    sortValue: function() {
        return this.get('priority')
    }.property('priority')
})
